import * as React from 'react';

import './InfoBanner.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

export interface InfoBannerProps {
  label: string;
  text: string;
}

export default class InfoBanner extends React.Component<InfoBannerProps, any> {
  public render() {
    return (
      <div className="info-banner">
        <div className="info-banner__icon">
          <FontAwesomeIcon icon={faInfo} />
        </div>
        <div className="info-banner__body">
          <div className="info-banner__label">{this.props.label}</div>
          <div className="info-banner__text">{this.props.text}</div>
        </div>
      </div>
    );
  }
}
